import { useTranslation } from 'react-i18next';
import { CircleCheckBig, Truck } from 'lucide-react';
import { Button } from '~/components/ui';
import type { OrderStatus } from '~/graphql/graphql.ts';
import { useShipOrderModal } from '~/pages/order-view/sections/useShipOrderModal';
import { useConfirmOrderModal } from '~/pages/order-view/sections/useConfirmOrderModal';

export function BuyerOrderCallToAction({
  orderId,
  orderStatus,
  awaitingPurchaseOrderNumber,
}: {
  orderId: string;
  orderStatus: OrderStatus;
  awaitingPurchaseOrderNumber: boolean;
}) {
  const { t } = useTranslation('order');
  const { shipModal, openShipModal, isShippingOrder } =
    useShipOrderModal(orderId);
  const { confirmModal, openConfirmModal, isConfirmingOrder } =
    useConfirmOrderModal(orderId);

  if (!['PENDING_SELLER_CONFIRMATION', 'CONFIRMED'].includes(orderStatus)) {
    return null;
  }

  return (
    <>
      {shipModal}
      {confirmModal}
      {orderStatus === 'PENDING_SELLER_CONFIRMATION' && (
        <Button
          onClick={openConfirmModal}
          disabled={isConfirmingOrder || awaitingPurchaseOrderNumber}
          title={
            awaitingPurchaseOrderNumber
              ? t('order.confirm_order_awaiting_po_number')
              : undefined
          }
          data-testid="buyer-confirm-order-button"
        >
          <CircleCheckBig size={18} />
          {t('order.confirm_order')}
        </Button>
      )}
      {orderStatus === 'PENDING_SELLER_CONFIRMATION' &&
        awaitingPurchaseOrderNumber && (
          <p className="text-xs text-neut-500">
            {t('order.confirm_order_awaiting_po_number')}
          </p>
        )}
      {orderStatus === 'CONFIRMED' && (
        <Button
          onClick={openShipModal}
          disabled={isShippingOrder}
          data-testid="buyer-ship-order-button"
        >
          <Truck size={18} />
          {t('order.ship_order')}
        </Button>
      )}
    </>
  );
}
